import { render, staticRenderFns } from "./report_detail.vue?vue&type=template&id=72cf5614&scoped=true&lang=pug&"
import script from "./report_detail.vue?vue&type=script&lang=js&"
export * from "./report_detail.vue?vue&type=script&lang=js&"
import style0 from "./report_detail.vue?vue&type=style&index=0&id=72cf5614&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf5614",
  null
  
)

export default component.exports